export const ApatheticTriangle: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M89.2851 68.9169L52.2303 5.23896C52.1957 5.17946 52.1322 5.14282 52.0633 5.14282L43.952 5.14282C43.8831 5.14282 43.8196 5.17946 43.7849 5.23896L6.73014 68.9169C6.58863 69.1606 6.51367 69.4373 6.51367 69.719L6.51367 80.5573C6.51367 80.6638 6.60006 80.7502 6.70695 80.7502L89.5012 80.7502H89.5016V69.719C89.5016 69.4373 89.4266 69.1606 89.2851 68.9169"
      fill="#F8FBCF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 75.2869V70.8993C12 70.8654 12.0091 70.8318 12.0262 70.8025L46.9862 10.7239C47.0208 10.6647 47.084 10.6284 47.1526 10.6284L49.079 10.6284C49.1476 10.6284 49.2111 10.6647 49.2454 10.7239L84.2054 70.8022C84.2225 70.8314 84.2316 70.8651 84.2316 70.899V75.2869C84.2316 75.3931 84.1452 75.4792 84.039 75.4792L12.1926 75.4792C12.0861 75.4792 12 75.3931 12 75.2869L52.6259 28.1713"
      fill="#F8DD3E"
    />
    <ellipse cx="47.9998" cy="61.3715" rx="15.0857" ry="2.74285" fill="#002F34" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.5272 50.3047C52.3445 50.3047 50.5742 48.5471 50.5742 46.379C50.5742 44.2108 52.3445 42.4539 54.5272 42.4539C56.7098 42.4539 58.4801 44.2108 58.4801 46.379C58.4801 48.5471 56.7098 50.3047 54.5272 50.3047"
      fill="#002F34"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.4178 50.3047C39.2352 50.3047 37.4648 48.5471 37.4648 46.379C37.4648 44.2108 39.2352 42.4539 41.4178 42.4539C43.6004 42.4539 45.3707 44.2108 45.3707 46.379C45.3707 48.5471 43.6004 50.3047 41.4178 50.3047"
      fill="#002F34"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5445 90.5618H18.2793V80.7732H21.5445V90.5618ZM77.8948 90.5618H74.6295V80.7732L77.8948 80.7732V90.5618Z"
      fill="#CFC980"
    />
  </svg>
);
